import React, { useState} from 'react';
import { Link } from 'react-router-dom';

export default function Card({title, projectid, display }) {
    const [currentImage, setCurrentImage] = useState(`https://schediopartners.com${display.data.attributes.url}`);
    const handleImageError = () => {
        const pngVersion = currentImage.replace(/.webp$/, '.png');
        setCurrentImage(pngVersion);
    };

    return (
        <Link to={`/portfolio/${projectid}`} className="w-full mb-6 cursor-pointer bg-[#f5f3f1] rounded-lg">
            <div className="relative group hover:bg-black transition-opacity duration-300 mb-1">
                <img 
                    src={currentImage} 
                    alt={title} 
                    className="w-full transition-opacity duration-300 group-hover:opacity-50" 
                    onError={handleImageError}
                />
                <div className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white">{title}</p>
                </div>
            </div>
        </Link>
    );
}
